import PiniaExampleView from './PiniaExampleView.vue';

const routes = [
  {
    name: 'pinia-example',
    path: '/advisor/pinia',
    component: PiniaExampleView,
  },
];

export default routes;
